<template>
  <div class="home-market-cooperation" ref="homeMarketCooperation">
    <img loading="lazy" class="home-market-cooperation-bg" src="@/assets/img/home/marketCooperationImg1.png" alt="">
    <Transition enter-active-class="animate__slideInUp" leave-active-class="animate__slideOutDown">
      <img loading="lazy" class="market-cooperation-text animate__animated " v-if="offsetTop < 650"
        src="@/assets/img/home/marketCooperationText1.png" alt="">
    </Transition>
    <Transition enter-active-class="animate__zoomIn" leave-active-class="animate__zoomOut">
      <img loading="lazy" class="img2 animate__animated " v-if="offsetTop < 650"
        src="@/assets/img/home/marketCooperationImg2.png" alt="">
    </Transition>
    <img loading="lazy" class="img3" src="@/assets/img/home/marketCooperationImg3.png" alt="">
    <el-button class="view-more-btn" type="primary" plain round size="medium"
      @click="$router.push('/marketCooperation')">查看更多</el-button>
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  props: ['offsetTop'],
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang='scss' scoped>
.home-market-cooperation {
  position: relative;
  height: 62.5rem;
  display: flex;
  justify-content: center;

  .home-market-cooperation-bg {
    width: 120rem;
    height: 62.5rem;
  }

  .market-cooperation-text {
    width: 66.125rem;
    height: 6.5rem;
    position: absolute;
    top: 2rem;
  }

  .img2 {
    position: absolute;
    top: 55%;
    transform: translateY(-50%);
    width: 66rem;
    height: 51.8125rem;
  }

  .img3 {
    position: absolute;
    right: 12rem;
    bottom: 7.5rem;
    width: 16.25rem;
    height: 24.4375rem;
  }

  .view-more-btn {
    position: absolute;
    background: transparent;
    color: #FFFFFF;
    border-color: #FFFFFF;
    right: 12.75rem;
    top: 12.5rem;
  }

  .view-more-btn:hover {
    color: #0096FF;
    border-color: #0096FF;
  }
}
</style>